import { render, staticRenderFns } from "./ResourceTreeItem.vue?vue&type=template&id=8a0f0508"
import script from "./ResourceTreeItem.vue?vue&type=script&lang=js"
export * from "./ResourceTreeItem.vue?vue&type=script&lang=js"
import style0 from "./ResourceTreeItem.vue?vue&type=style&index=0&id=8a0f0508&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports